import makeStyles from '@material-ui/styles/makeStyles';

export const useStyles = makeStyles(theme => ({
  button: {
    color: 'var(--prs-c-primary)',
    fill: 'var(--prs-c-primary)',
    backgroundColor: theme.palette.base.offWhite,
  },
  buttonText: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  label: {
    width: '100%',
  },
  labelText: {
    marginRight: '20px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  paper: {
    color: 'var(--prs-c-primary)',
    fill: 'var(--prs-c-primary)',
    borderRadius: 0,
    textTransform: 'capitalize',
    border: `1px solid ${theme.palette.gray.dark}`,
    width: '220px',
  },
  list: {
    paddingTop: 0,
    paddingBottom: 0,
  },
  menuItem: {
    fontSize: '0.95rem',
    minHeight: '48px',
    '&:focus': {
      backgroundColor: 'var(--prs-c-primary)',
      color: theme.palette.base.white,
      fill: theme.palette.base.white,
    },
    '&:hover': {
      backgroundColor: 'var(--prs-c-primary)',
      color: theme.palette.base.white,
      fill: theme.palette.base.white,
    },
    '&.Mui-disabled': {
      color: theme.palette.gray.base,
      fill: theme.palette.gray.medium,
    },
  },
  menuItemIcon: {
    position: 'absolute',
    right: '10px',
  },
  menuBtnIcon: {
    position: 'absolute',
    right: '10px',
    maxWidth: '15px',
    maxHeight: '11px',
    '&:focus': {
      outline: 'none',
    },
  },
}));
